// Copyright 2025. WebPros International GmbH. All rights reserved.

export const LOGIN_FORM = {
    EMAIL: 'email',
    PASSWORD: 'password',
    SUBMIT: 'submit',
    PASSWORD_RECOVERY_BUTTON: 'password-recovery',
};
